import { h } from 'vue';

export default {
    // functional: true,

    props:
    {
        label:
        {
            type: String,
            default: null,
        },
    },

    render()
    {
        return h(
            'div',
            {
                // staticClass: data.staticClass,

                class:
                [
                    'vh-card',
                    'vh-card-body',
                    'vh-padding-small',
                    'vh-text-center',
                ],
            },
            [
                h(
                    'h3',

                    this.label
                ),

                h(
                    'img',

                    {
                        class:
                        [
                            // 'vh-margin-xsmall-top',
                        ],
                        src: '/assets/image/illustrations/checking.png',
                        alt: 'Empty Illustration',
                        width: '300',
                        height: '300',
                    },
                ),
            ]
        );
    },
};
